
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/march-madness-tool",
      function () {
        return require("private-next-pages/march-madness-tool/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/march-madness-tool"])
      });
    }
  